import request from '@/utils/request'

/** 拓客活动分页列表 */
export function getLqEventList(data) {
  return request({
    url: '/api/Extend/LqEvent',
    method: 'get',
    data
  })
}

/** 当前用户参与的进行中拓客活动 */
export function getCurrentEventByUser(userId) {
  return request({
    url: `/api/Extend/LqEvent/user/${userId}/current`,
    method: 'get'
  })
}
